export const maskPostalCode = {
    name: 'Postal Code',
    description: "Mask postal codes e.g. '1234AB', '1234 AB'",
    exceptions: [],
    filterRegex: /\b[1-9][0-9]{3}\s?[a-zA-Z]{2}\b/g,
};
